import * as z from "zod/v4";

export const ConfirmUploadedImageForProductVisualizationSchema = z.object({
  modelImageHash: z
    .string()
    .describe("The SHA-256 hash of the uploaded model image"),
  modelImageExtension: z
    .string()
    .describe(
      "The file extension of the uploaded model image (e.g., png, jpg, webp)",
    ),
  modelImageUrl: z.string().describe("The URL of the uploaded model image"),
});

export type ConfirmUploadedImageForProductVisualization = z.infer<
  typeof ConfirmUploadedImageForProductVisualizationSchema
>;
